export const INVITATION_EMAIL_MISMATCH_ERROR =
  'This invitation was sent to a different email address. Please log in with the invited account to accept it.';

export const INVITATION_STATE = {
  UNKNOWN: 'unknown',
  CREATED: 'created',
  USED: 'used',
  DELETED: 'deleted',
};
